import React from 'react';
import { Link } from 'react-router-dom';
import useI18n from '../hooks/useI18n';
import { LinkedinLogo, TiktokLogo } from '@phosphor-icons/react';
import WotBadge from './WotBadge';

/**
 * Single site-wide footer (copyright, WOT trust badge, social links), shared
 * by every page via AppShell so it renders identically everywhere instead of
 * being duplicated (or half-duplicated) per page.
 */
export default function SiteFooter() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-line py-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:grid sm:grid-cols-3 items-center gap-4">
        <p className="text-text-muted text-xs font-mono sm:justify-self-start">
          &copy; {new Date().getFullYear()} Gabriele Denaro. Tutti i diritti riservati.
          <span className="block sm:inline sm:ml-3 mt-1 sm:mt-0 space-x-3">
            <Link to="/privacy" className="hover:text-accent underline underline-offset-2" data-testid="footer-privacy">{t('footer.privacy')}</Link>
            <Link to="/condizioni" className="hover:text-accent underline underline-offset-2" data-testid="footer-terms">{t('footer.terms')}</Link>
          </span>
        </p>
        <div className="sm:justify-self-center">
          <WotBadge />
        </div>
        <div className="flex gap-4 sm:justify-self-end">
          <a href="https://www.linkedin.com/in/gabriele-denaro/" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-accent transition-colors" aria-label="LinkedIn">
            <LinkedinLogo size={20} />
          </a>
          <a href="https://www.tiktok.com/@denaro.gabriele" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-accent transition-colors" aria-label="TikTok">
            <TiktokLogo size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
}
